var map = {
	"./memory-card-burger.png": 9259,
	"./memory-card-candy.png": 2579,
	"./memory-card-chicken.png": 6370,
	"./memory-card-chocolate.png": 8598,
	"./memory-card-coffee.png": 8794,
	"./memory-card-cookie.png": 3900,
	"./memory-card-donut.png": 7493,
	"./memory-card-drinks.png": 728,
	"./memory-card-egg.png": 9389,
	"./memory-card-evil.png": 1863,
	"./memory-card-fries.png": 6863,
	"./memory-card-front.png": 7860,
	"./memory-card-icecream.png": 9710,
	"./memory-card-lollipop.png": 2771,
	"./memory-card-milk.png": 4990,
	"./memory-card-milkshake.png": 7470,
	"./memory-card-pizza.png": 6067,
	"./memory-card-popcorn.png": 2111,
	"./memory-card-popsicle.png": 2628,
	"./memory-card-taco.png": 8241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1126;